export enum QuiltySubscriptionPlanType {
    Basic = "basic",
    Intelligence = "intelligence",
    Enterprise = "enterprise",
}

type IntervalUnit = "day" | "week" | "month" | "year";
export interface QuiltySubscriptionPlan {
    name: string;
    plan: QuiltySubscriptionPlanType;
    price?: number; // In cents
    interval: IntervalUnit;
    intervalCount: number;
}

export const QUILTY_SUBCSCRIPTION_PLANS: QuiltySubscriptionPlan[] = [
    {
        plan: QuiltySubscriptionPlanType.Basic,
        name: "Financial",
        interval: "year",
        intervalCount: 1,
    },
    {
        plan: QuiltySubscriptionPlanType.Intelligence,
        name: "Intelligence",
        interval: "year",
        intervalCount: 1,
    },
    {
        plan: QuiltySubscriptionPlanType.Enterprise,
        name: "Enterprise",
        interval: "year",
        intervalCount: 1,
    },
];
